import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import moment from 'moment';
import { clearSelect } from '../pages/Calculator/calculator';


export const onExporting = (e) => {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('Main sheet');
  exportDataGrid({
    component: e.component,
    worksheet: worksheet,
    customizeCell: function (options) {
      const excelCell = options;
      excelCell.font = { name: 'Arial', size: 12 };
      excelCell.alignment = { horizontal: 'left' };
    }
  }).then(function () {
    workbook.xlsx.writeBuffer()
      .then(function (buffer) {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
      });
  });
  e.cancel = true;
}

export const ButtonOnExporting = (e, ref, fileName = "DataGrid", workSheet = "Main sheet") => {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet(workSheet);

  const dataGrid = ref.current.instance;

  exportDataGrid({
    component: dataGrid,
    worksheet: worksheet,
    customizeCell: function (options) {
      const excelCell = options;
      excelCell.font = { name: 'Arial', size: 12 };
      excelCell.alignment = { horizontal: 'left' };
      excelCell.wrapText = true;
    }
  }).then(function () {
    // saat dakika saniye
    let filenamewidthHour = fileName + "" + moment(new Date()).format("_HHmmss");
    workbook.xlsx.writeBuffer()
      .then(function (buffer) {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${filenamewidthHour}.xlsx`);
      });
  });
  clearSelect()
  e.cancel = true;
}

export const ButtonOnExportingForMasterDetail = (bulkData, columns, e, ref, fileName = "DataGrid") => {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('Main sheet');

  let masterRows = []
  const dataGrid = ref.current.instance;

  exportDataGrid({
    component: dataGrid,
    worksheet: worksheet,
    autoFilterEnabled: true,

    customizeCell: function (options) {
      const excelCell = options.excelCell;
      const gridCell = options.gridCell;
      options.font = { name: 'Arial', size: 12 };
      options.alignment = { horizontal: 'left' };
      if (
        gridCell.column.dataField === "TarihSaat" &&
        gridCell.rowType === "data"
      ) {
        masterRows.push({
          rowIndex: excelCell.fullAddress.row + 1,
          data: gridCell.data
        });
      }
    }
  }).then((cellRange) => {
    const borderStyle = { style: "thin", color: { argb: "FF7E7E7E" } };
    let offset = 0;

    const insertRow = (index, offset, outlineLevel) => {
      const currentIndex = index + offset;
      debugger;
      const row = worksheet.insertRow(currentIndex, [], "n");

      for (var j = worksheet.rowCount + 1; j > currentIndex; j--) {
        worksheet.getRow(j).outlineLevel = worksheet.getRow(
          j - 1
        ).outlineLevel;
      }

      row.outlineLevel = outlineLevel;

      return row;
    };

    for (let i = 0; i < masterRows.length; i++) { // Changed 'var' to 'let'
      let row = insertRow(masterRows[i].rowIndex + i, offset++, 2);
      let columnIndex = cellRange.from.column + 1;
      row.height = 20;

      let employeeData = bulkData.__rawData.find(
        (item) => item.ID === masterRows[i].data.ID
      );

      Object.assign(row.getCell(columnIndex), {
        value: "Detail",
        fill: {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "BEDFE6" }
        }
      });
      worksheet.mergeCells(row.number, columnIndex, row.number, columns.length + 1);

      row = insertRow(masterRows[i].rowIndex + i, offset++, 2);
      columns.forEach((columnName, currentColumnIndex) => {
        Object.assign(row.getCell(columnIndex + currentColumnIndex), {
          value: columnName,
          fill: {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "BEDFE6" }
          },
          font: { bold: true },
          border: {
            bottom: borderStyle,
            left: borderStyle,
            right: borderStyle,
            top: borderStyle
          }
        });
      });

      let results = employeeData.AntimonDetail

      //eslint-disable-next-line
      results.forEach((task, index) => {
        let localOffset = offset++;  // Create a local copy for each iteration

        row = insertRow(masterRows[i].rowIndex + i, localOffset, 2);

        columns.forEach((columnName, currentColumnIndex) => {
          Object.assign(row.getCell(columnIndex + currentColumnIndex), {
            value: task[columnName],
            fill: {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "BEDFE6" }
            },
            border: {
              bottom: borderStyle,
              left: borderStyle,
              right: borderStyle,
              top: borderStyle
            }
          });
        });
      });

      offset--;

      // // Boş satır
      // row = insertRow(masterRows[i].rowIndex + i + 1, offset++, 2);
      // Object.assign(row.getCell(columnIndex), {
      //   value: "",
      // });

      // // İkinci Detay Tablosunun Başlık Sütunu
      // row = insertRow(masterRows[i].rowIndex + i + 1, offset++, 2);
      // row.height = 20;
      // Object.assign(row.getCell(columnIndex), {
      //   value: "Detail2",
      //   fill: {
      //     type: "pattern",
      //     pattern: "solid",
      //     fgColor: { argb: "BEDFE6" }
      //   }
      // });

      // worksheet.mergeCells(row.number, columnIndex, row.number, columns.length + 1);
      // row = insertRow(masterRows[i].rowIndex + i + 1, offset++, 2);

      // columns.forEach((columnName, currentColumnIndex) => {
      //   Object.assign(row.getCell(columnIndex + currentColumnIndex), {
      //     value: columnName,
      //     fill: {
      //       type: "pattern",
      //       pattern: "solid",
      //       fgColor: { argb: "BEDFE6" }
      //     },
      //     font: { bold: true },
      //     border: {
      //       bottom: borderStyle,
      //       left: borderStyle,
      //       right: borderStyle,
      //       top: borderStyle
      //     }
      //   });
      // });


    }

  }).then(function () {
    workbook.xlsx.writeBuffer()
      .then(function (buffer) {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${fileName}.xlsx`);
      });
  });
  e.cancel = true;
}
